import React from "react";
import { Partner } from "../../api";
import { PartnerConfig } from "../../partner_config";
import { Spacer } from "../../spacer";
import { PortalBookingList } from "../components/portal_booking_list";
import { TemplatePartnerPortalIndexV2 } from "./template_partner_portal_index_v2";
import styles from "./portal_all_bookings_page.module.css";
import { useMediaQuery } from "../../../hooks";

interface PortalAllBookingsPageProps {
  partnerConfig: PartnerConfig;
  partner: Partner;
}

export function PortalAllBookingsPage({
  partnerConfig,
  partner,
}: PortalAllBookingsPageProps) {
  const { device } = useMediaQuery();

  return (
    <TemplatePartnerPortalIndexV2
      partner={partner}
      partnerConfig={partnerConfig}
    >
      <div>
        <Spacer size={device === "mobile" ? 16 : 81} />
        <div className={styles.title}>All Bookings</div>
        <Spacer size={device === "mobile" ? 16 : 20} />
        <div>
          Your membership bookings, multi pass bookings, and on-demand bookings,
          all in one place.
        </div>
        <Spacer size={device === "mobile" ? 32 : 40} />
        <PortalBookingList partnerId={partner.id} />
      </div>
    </TemplatePartnerPortalIndexV2>
  );
}
